import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect } from "react";
import VaporDrawer from "../../general/vapor/drawer";
import "./style.css";
import RecurrentPaymentForm from "../create/recurrentPaymentForm";
import { Button } from "@ts-digital/vrc";
import RegistryForm from "../create/registryForm";
import isoCountriesLanguages from "iso-countries-languages";
import { useDispatch, useSelector } from "react-redux";
import { editParty } from "../../../store/actions/parties";
import { validator } from "../../../libs/validator";
import iban from "iban";
import InstallmentSummary from "./installmentSummary";

const PartiesDetail = props => {
  const {
    registryStore,
    address,
    onClose,
    setTypeEditing,
    isEditingState,
    installments
  } = props;

  const [selectedTab, setSelectedTab] = useState(1);
  const [editContactBody, setEditContactBody] = useState([]);
  const [editVatNumber, setEditVatNumber] = useState([]);
  const [editTaxId, setEditTaxId] = useState([]);
  const [editEoriNumber, setEditEoriNumber] = useState([]);
  const [editEmailAddress, setEditEmailAddress] = useState([]);
  const [editPecAddress, setEditPecAddress] = useState([]);
  const [editAddress, setEditAddress] = useState({
    region: "",
    country: "",
    municipality: "",
    cap: "",
    province: "",
    street: { additionalInfo: "", name: "", number: "" }
  });
  const [municipalityEditError, setMunicipalityEditError] = useState(null);
  const [provinceEditError, setProvinceEditError] = useState(null);
  const [capEditError, setCapEditError] = useState(null);
  const [pecEditError, setPecEditError] = useState(null);
  const [ibanEditError, setEditIbanError] = useState(null);
  const [emailEditError, setEditEmailError] = useState(null);
  const [taxIdEditError, setTaxIdEditError] = useState(null);
  const [vatEditError, setEditVatError] = useState(null);
  const [readyToEditContact, setReadyToEditContact] = useState(false);
  const [negotiatedPaymentPlan, setNegiotatedPaymentPlan] = useState([]);
  const [installmentsRounded, setInstallmentsRounded] = useState([]);
  const [installmentsToEdit, setInstallmentsToEdit] = useState([]);
  const auth = useSelector(state => state.auth);
  const main = useSelector(state => state.main);
  const dispatch = useDispatch();
  const partyId = address?._meta.id;
  const version = address?._meta.version;

  const cfpiva = require("cfpiva");

  useEffect(() => {
    const countriesInItalian = Object.values(isoCountriesLanguages.getCountries("it"));
    registryStore.setCountries(countriesInItalian);
  }, []);

  useEffect(() => {
    if (readyToEditContact) {
      dispatch(editParty(
        auth,
        main.companyUuidSelected,
        editContactBody,
        partyId,
        version
      )).then(res => {
        setTypeEditing(isEditingState.error === false ? "success" : "error");
        onClose(null);
      });
    }
    setReadyToEditContact(false);
  }, [readyToEditContact]);

  useEffect(() => {
    onBlurEditTaxIdValue(editTaxId, editAddress?.country);
    onBlurEditVatNumberValue(editVatNumber, editAddress?.country);
  }, [editAddress?.country]);

  useEffect(() => {
    if (address?.negotiatedPaymentPlans?.[0]?.installments) {
      setNegiotatedPaymentPlan([
        ...address?.negotiatedPaymentPlans?.[0]?.installments
      ]);
    }
  }, [address]);

  useEffect(() => {
    onBlurEditTaxIdValue(editTaxId, editAddress?.country);
  }, [editContactBody?.type, editAddress?.country]);

  useEffect(() => {
    const amounts = installmentsToEdit?.map(i => Math.floor(i.amount));
    const sum = amounts?.reduce((a, b) => a + b, 0);
    const difference = 100 - sum;
    const calcRoundedAm = (i, index) => {
      if (sum < 100) {
        if (index === installmentsToEdit?.length - 1) {
          return Math.floor(i.amount + difference);
        } 
        return Math.floor(i.amount);
        
      } else if (sum > 100) {
        if (index === installmentsToEdit?.length - 1) {
          return Math.floor(i.amount + difference);
        } 
        return Math.floor(i.amount);
        
      } 
      return Math.floor(i.amount);
      
    };

    const installmentsRoundedAmToIterate =  address?.negotiatedPaymentPlans.length > 0 ? installmentsToEdit : installments;

    const installmentsRoundedAm = installmentsRoundedAmToIterate?.map((i, index) => {
      return {
        ...i,
        amount: calcRoundedAm(i, index)
      };
    });

    setInstallmentsRounded([...installmentsRoundedAm]);
  }, [installmentsToEdit, installments]);

  const onEditCountry = value => {
    const newAddress = { ...editAddress };
    newAddress.country = value;
    setEditAddress({ ...newAddress });
    setMunicipalityEditError(value === "Italia" ? true : null);
    setProvinceEditError(value === "Italia" ? true : null);
    setCapEditError(value === "Italia" ? true : null);
  };

  const onBlurEditMunicipality = e => {
    if (editAddress.country === "Italia" || e === "Italia") {
      const { matchingCity } = registryStore.getMatchingCityAndState(e);
      setMunicipalityEditError(matchingCity === undefined ? true : false);
      setCapEditError(true);
      setProvinceEditError(true);
    }
  };
  const onBlurEditCap = e => {
    if (editAddress.country === "Italia") {
      const { matchingCity } = registryStore.getMatchingCityAndState(editAddress.municipality);
      const insertedValue = e.target.value;
      const insertedFirstThree = insertedValue.substring(0, 3);
      if (!matchingCity?.cap.includes("x")) {
        setCapEditError(insertedValue === matchingCity?.cap ? false : true);
      } else {
        setCapEditError(matchingCity?.cap.includes(insertedFirstThree) ? false : true);
      }
    }
  };

  const onBlurEditProvince = e => {
    if (editAddress.country === "Italia" || e === "Italia") {
      const { matchingState } = registryStore.getMatchingCityAndState(editAddress.municipality);
      const insertedValue = e.target.value;
      setProvinceEditError(insertedValue === matchingState?.code ||
          insertedValue === matchingState?.nome
        ? false
        : true);
    }
  };

  const onBlurEditPec = e => {
    if (e.target.value.length > 0) {
      const isValidPec = validator.isEmail(e.target.value);
      setPecEditError(isValidPec ? false : true);
    }
  };

  const onBlurEditTaxId = e => {
    if (editAddress.country === "Italia") {
      let isValidTaxId;
      let isValidVatNumber;
      if (e !== undefined) {
        if (e.target !== undefined && e.target.value.length > 0) {
          isValidTaxId = cfpiva.controllaCF(e.target.value);
          isValidVatNumber = cfpiva.controllaPIVA(e.target.value);
        }
        if (editContactBody.type === "PERSON" && e.target !== undefined) {
          if (e.target.value.length > 0) {
            setTaxIdEditError(isValidTaxId ? false : true);
          } else {
            setTaxIdEditError(null);
          }
        }
        if (editContactBody.type === "COMPANY" && e.target !== undefined) {
          if (e.target.value.length > 0) {
            setTaxIdEditError(isValidTaxId || isValidVatNumber ? false : true);
          } else {
            setTaxIdEditError(null);
          }
        }
      }
    }
  };

  const onBlurEditVatNumber = e => {
    if (editAddress.country === "Italia" && e.target.value.length > 0) {
      const isValidVatNumber = cfpiva.controllaPIVA(e.target.value);
      setEditVatError(isValidVatNumber ? false : true);
    } else {
      setEditVatError(null);
    }
  };

  const onBlurEditVatNumberValue = (vatNumber, country) => {
    if (vatNumber !== undefined) {
      if (vatNumber.length > 0 && country === "Italia") {
        const isValidVatNumber = cfpiva.controllaPIVA(editVatNumber);
        setEditVatError(isValidVatNumber ? false : true);
      } else {
        setEditVatError(null);
      }
    }
  };

  const onBlurEditTaxIdValue = (taxId, country) => {
    if (taxId !== undefined) {
      if (taxId.length > 0 && country === "Italia") {
        const isValidVatNumber = cfpiva.controllaPIVA(taxId);
        const isValidTaxId = cfpiva.controllaCF(taxId);
        if (editContactBody.type === "PERSON") {
          setTaxIdEditError(isValidTaxId ? false : true);
        }
        if (editContactBody.type === "COMPANY") {
          setTaxIdEditError(isValidTaxId || isValidVatNumber ? false : true);
        }
      } else {
        setTaxIdEditError(null);
      }
    }
  };

  const onChangeEditIban = e => {
    if (e.target.value.length > 0) {
      const isValidIban = iban.isValid(e.target.value);
      setEditIbanError(isValidIban ? false : true);
    } else {
      setEditIbanError(null);
    }
  };

  const onChangeEditIbanValue = e => {
    const editContactBodyCopy = { ...editContactBody };
    const newContactBody = {
      ...editContactBodyCopy,
      bankAccounts: [
        {
          ...editContactBodyCopy?.bankAccounts?.[0],
          iban: e.target.value
        }
      ]
    };
    setEditContactBody({
      ...newContactBody
    });
    onChangeEditIban(e);
  };

  const onBlurEditEmail = e => {
    const isValidEmail = validator.isEmail(e.target.value);
    setEditEmailError(isValidEmail ? false : true);
  };

  const street = address?.places[0].address?.street?.name;
  const number = address?.places[0].address?.street?.number;
  const city = address?.places[0].address?.municipality;
  const postalCode = address?.places[0].address?.postalCode;
  const province = address?.places[0].address?.province;
  const country = address?.places[0].address?.country;

  const completeAddress = `${street}, ${number} - ${city} ${postalCode} - ${province}, ${country} `;

  const vatNumber = address?.identifiers[0]?.value;
  const taxId = address?.identifiers[1]?.value;

  const installmentsToSave = installmentsRounded?.map(i => {
    return {
      paymentMethods: [i.paymentMethod],
      fractionOver10K: i.amount * 100,
      dueDate: {
        days:
          i.dueDate?.interval === "giorni"
            ? i.dueDate?.number
            : i.dueDate?.number * 30,
        from:
          i.dueDate?.from === "month-end"
            ? "DOCUMENT_DATE_END_OF_MONTH"
            : "DOCUMENT_DATE"
      }
    };
  });

  const calculatedDescription = () => {
    if (editContactBody?.length !== 0) {
      return editContactBody?.type === "PERSON"
        ? `${editContactBody.firstName} ${editContactBody.lastName}`
        : editContactBody?.description
          ? editContactBody?.description
          : "";
    } 
    return address?.type === "PERSON"
      ? `${address.firstName} ${address.lastName}`
      : address?.description
        ? address?.description
        : "";
    
  };

  const editContact = () => {
    let identifiers = [];
    let emailAddresses = [];
    if (editVatNumber !== undefined) {
      if (editVatNumber.length > 0) {
        identifiers.push({
          type: "VAT_NUMBER",
          country: editAddress?.country,
          value: editVatNumber
        });
      }
    }
    if (editTaxId !== undefined) {
      if (editTaxId.length > 0) {
        identifiers.push({
          type: "TAX_ID",
          country: editAddress?.country,
          value: editTaxId
        });
      }
    }
    if (editEoriNumber !== undefined) {
      if (editEoriNumber.length > 0) {
        identifiers.push({
          type: "EORI_NUMBER",
          country: editAddress?.country,
          value: editEoriNumber
        });
      }
    }
    if (editEmailAddress !== undefined) {
      if (editEmailAddress.length > 0) {
        emailAddresses.push({
          description: "",
          type: "STANDARD",
          value: editEmailAddress,
          scopes: address?.emailAddresses?.[0]?.scopes
            ? [...address?.emailAddresses?.[0]?.scopes]
            : []
        });
      }
    }
    if (editPecAddress !== undefined) {
      if (editPecAddress.length > 0) {
        emailAddresses.push({
          description: "",
          type: "PEC",
          value: editPecAddress,
          scopes: address?.emailAddresses?.[1]?.scopes
            ? [...address?.emailAddresses?.[1]?.scopes]
            : []
        });
      }
    }

    setEditContactBody({
      ...editContactBody,
      description: calculatedDescription(),
      identifiers: identifiers.length > 0 ? identifiers : address?.identifiers,
      emailAddresses:
        emailAddresses?.length > 0 ? emailAddresses : address?.emailAddresses,
      places: [
        {
          description: "",
          address: {
            country: editAddress?.country
              ? editAddress?.country
              : address?.places?.[0]?.address?.country,
            region: editAddress?.region
              ? editAddress?.region
              : address?.places?.[0]?.address?.region,
            province: editAddress?.province
              ? editAddress?.province
              : address?.places?.[0]?.address?.province,
            municipality: editAddress?.municipality
              ? editAddress?.municipality
              : address?.places?.[0]?.address?.municipality,
            city: null,
            street:
              editAddress?.street?.name !== "" ||
              editAddress?.street?.number !== ""
                ? {
                  ...editAddress?.street
                }
                : {
                  ...address?.places?.[0]?.address?.street
                },
            postalCode: editAddress?.postalCode
              ? editAddress?.postalCode
              : address?.places?.[0]?.address?.postalCode
          },
          scopes: address?.places?.[0]?.scopes
            ? [...address?.places?.[0]?.scopes]
            : []
        }
      ],
      bankAccounts: [
        {
          description: "",
          iban: (editContactBody?.bankAccounts && editContactBody?.bankAccounts[0]?.iban)
            ? editContactBody?.bankAccounts[0]?.iban
            : address?.bankAccounts?.[0]?.iban,
          swiftCode: "",
          abiCode: "",
          cabCode: "",
          scopes: address?.bankAccounts?.[0]?.scopes
            ? [...address?.bankAccounts?.[0]?.scopes]
            : []
        }
      ],
      sdiId: editContactBody?.sdiId ? editContactBody?.sdiId : address?.sdiId,
      taxRepresentative: {
        identifiers: [],
        name: "",
        firstName: "",
        lastName: ""
      },
      firstName: editContactBody?.firstName
        ? editContactBody?.firstName
        : address?.firstName
          ? address?.firstName
          : "",
      lastName: editContactBody?.lastName
        ? editContactBody?.lastName
        : address?.lastName
          ? address?.lastName
          : "",
      rea: editContactBody.rea
        ? editContactBody.rea
        : address?.rea
          ? address?.rea
          : "",
      relationships: editContactBody.relationships
        ? editContactBody.relationships
        : address?.relationships,
      type: editContactBody.type ? editContactBody?.type : address?.type,
      name: editContactBody?.name
        ? editContactBody?.name
        : address?.name
          ? address?.name
          : "",
      legalNature: editContactBody?.legalNature
        ? editContactBody?.legalNature
        : address?.legalNature
          ? address?.legalNature
          : "",
      negotiatedPaymentPlans:
        (installmentsToEdit.length > 0 && address?.negotiatedPaymentPlans) || (installments?.length > 0 && address?.negotiatedPaymentPlans?.length === 0)
          ? [
            {
              installments: [...installmentsToSave],
              scopes: address?.negotiatedPaymentPlans?.[0]?.scopes
                ? [
                  ...address?.negotiatedPaymentPlans?.[0]?.scopes,
                  editContactBody?.paymentScopes
                    ? editContactBody?.paymentScopes
                    : "null"
                ]
                : [
                  editContactBody?.paymentScopes
                    ? editContactBody?.paymentScopes
                    : "null"
                ]
            }
          ]
          : address?.negotiatedPaymentPlans?.[0]?.installments
            ? [
              {
                installments: [
                  ...address?.negotiatedPaymentPlans?.[0]?.installments
                ],
                scopes: address?.negotiatedPaymentPlans?.[0]?.scopes
                  ? [address?.paymentScopes ? address?.paymentScopes : "null"]
                  : [address?.paymentScopes ? address?.paymentScopes : "null"]
              }
            ]
            : []
    });
    setReadyToEditContact(true);
  };

  const buttonActiveConditions = () => {
    if (editContactBody.length !== 0) {
      if (editContactBody?.type === "PERSON") {
        if (
          editContactBody?.firstName?.length > 0 &&
          editContactBody?.lastName?.length > 0 &&
          editContactBody?.relationships?.length > 0 &&
          editAddress?.country?.length > 0 &&
          editAddress?.municipality?.length > 0 &&
          editAddress?.postalCode?.length > 0 &&
          editAddress?.province?.length > 0 &&
          editAddress?.street?.name?.length > 0 &&
          editAddress?.street?.number?.length > 0 &&
          editEmailAddress?.length > 0 &&
          !municipalityEditError &&
          !provinceEditError &&
          !capEditError &&
          !emailEditError &&
          (!ibanEditError || ibanEditError === null) &&
          (!pecEditError || pecEditError === null) &&
          (!taxIdEditError || taxIdEditError === null) &&
          (!vatEditError || vatEditError === null) &&
          (!registryStore.installmentsError ||
            registryStore.installmentsError === null)
        ) {
          return true;
        } 
        return false;
        
      } 
      if (
        editContactBody?.description?.length > 0 &&
          editContactBody?.relationships?.length > 0 &&
          editAddress?.country?.length > 0 &&
          editAddress?.municipality?.length > 0 &&
          editAddress?.postalCode?.length > 0 &&
          editAddress?.province?.length > 0 &&
          editAddress?.street?.name?.length > 0 &&
          editAddress?.street?.number?.length > 0 &&
          editEmailAddress?.length > 0 &&
          !municipalityEditError &&
          !provinceEditError &&
          !capEditError &&
          !emailEditError &&
          (!ibanEditError || ibanEditError === null) &&
          (!pecEditError || pecEditError === null) &&
          (!taxIdEditError || taxIdEditError === null) &&
          (!vatEditError || vatEditError === null) &&
          (!registryStore.installmentsError ||
            registryStore.installmentsError === null)
      ) {
        return true;
      } 
      return false;
      
    } 
    if (address?.type === "PERSON") {
      if (
        address?.firstName?.length > 0 &&
          address?.lastName?.length > 0 &&
          address?.relationships?.length > 0 &&
          address?.places?.[0]?.address?.country.length > 0 &&
          address?.places?.[0]?.address?.municipality?.length > 0 &&
          address?.places?.[0]?.address?.postalCode?.length > 0 &&
          address?.places?.[0]?.address?.province?.length > 0 &&
          address?.places?.[0]?.address?.street?.name?.length > 0 &&
          address?.places?.[0]?.address?.street?.number?.length > 0 &&
          address?.emailAddresses?.[0]?.value?.length > 0 &&
          !municipalityEditError &&
          !provinceEditError &&
          !capEditError &&
          !emailEditError &&
          (!ibanEditError || ibanEditError === null) &&
          (!pecEditError || pecEditError === null) &&
          (!taxIdEditError || taxIdEditError === null) &&
          (!vatEditError || vatEditError === null) &&
          (!registryStore.installmentsError ||
            registryStore.installmentsError === null)
      ) {
        return true;
      } 
      return false;
        
    } 
    if (
      address?.description?.length > 0 &&
          address?.relationships?.length > 0 &&
          address?.places?.[0]?.address?.country.length > 0 &&
          address?.places?.[0]?.address?.municipality?.length > 0 &&
          address?.places?.[0]?.address?.postalCode?.length > 0 &&
          address?.places?.[0]?.address?.province?.length > 0 &&
          address?.places?.[0]?.address?.street?.name?.length > 0 &&
          address?.places?.[0]?.address?.street?.number?.length > 0 &&
          address?.emailAddresses?.[0]?.value?.length > 0 &&
          !municipalityEditError &&
          !provinceEditError &&
          !capEditError &&
          !emailEditError &&
          (!ibanEditError || ibanEditError === null) &&
          (!pecEditError || pecEditError === null) &&
          (!taxIdEditError || taxIdEditError === null) &&
          (!vatEditError || vatEditError === null) &&
          (!registryStore.installmentsError ||
            registryStore.installmentsError === null)
    ) {
      return true;
    } 
    return false;
    
  };

  const pecAddressObject = address?.emailAddresses?.find(e => e.type === "PEC");
  const contactPecAddress = pecAddressObject?.value;

  const taxIdObject = address?.identifiers?.find(i => i.type === "TAX_ID");
  const contactTaxId = taxIdObject?.value;

  const vatObject = address?.identifiers?.find(i => i.type === "VAT_NUMBER");
  const contactVatNumber = vatObject?.value;
  const calculateTitle = () => {
    if (address?.relationships?.length === 1) {
      if (address?.relationships[0] === "CUSTOMER") {
        return "DETTAGLI CLIENTE";
      } 
      return "DETTAGLI FORNITORE";
      
    } 
    return "DETTAGLI CLIENTE/FORNITORE";
    
  };

  return (
    <VaporDrawer
      title={calculateTitle()}
      subtitle={""}
      visible={address}
      onClose={() => onClose(null)}
      width={selectedTab === 3 || selectedTab === 4 ? 1200 : 800}
      hideFooter
    >
      <div className="dbx-parties-detail-header">
        <div className="dbx-parties-detail-header-tabs">
          <div
            onClick={() => {
              setSelectedTab(1);
            }}
            className={
              "dbx-parties-detail-header-tab" +
              (selectedTab === 1 || selectedTab === 3 ? " active" : "")
            }
          >
            Anagrafica
          </div>
          <div
            onClick={() => {
              setSelectedTab(address?.negotiatedPaymentPlans.length > 0 ? 2 : 4);
            }}
            className={
              "dbx-parties-detail-header-tab" +
                (selectedTab === 2 || selectedTab === 4 ? " active" : "")
            }
          >
              Rapporti commerciali
          </div>
        </div>
      </div>
      <div className="dbx-parties-detail-body">
        {selectedTab === 1 ? (
          <div className="dbx-parties-detail-body-identifying">
            <div className="dbx-parties-detail-body-identifying-top">
              <div className="dbx-parties-detail-body-identifying-name">
                <div className="dbx-parties-detail-body-identifying-name-left">
                  <div className="dbx-parties-detail-body-identifying-name-icon">
                    <FontAwesomeIcon
                      icon={[
                        "far",
                        address.type === "COMPANY" ? "building" : "user"
                      ]}
                    />
                  </div>
                  <div className="dbx-parties-detail-body-identifying-name-text">
                    {address.description}
                  </div>
                </div>
                <div className="dbx-parties-detail-body-identifying-name-right">
                  <div className="dbx-parties-detail-body-identifying-name-edit">
                    <FontAwesomeIcon
                      icon={["far", "edit"]}
                      onClick={() => setSelectedTab(3)}
                    />
                  </div>
                </div>
              </div>
              <div className="dbx-parties-detail-body-identifying-type-category">
                <div className="dbx-parties-detail-body-identifying-type-category-type">
                  {address.type === "COMPANY" ? "Azienda" : "Persona fisica"}
                </div>
                {address?.relationships.map((r, index) => {
                  return (
                    <div key={`relationshipsAddress_${index}`} className="dbx-parties-detail-body-identifying-type-category-category">
                      <div className="dbx-parties-detail-body-identifying-type-category-category-icon">
                        <FontAwesomeIcon
                          icon={["far", r === "CUSTOMER" ? "male" : "truck"]}
                        />
                      </div>
                      <div className="dbx-parties-detail-body-identifying-type-category-category-text">
                        {r === "CUSTOMER" ? "CLIENTE" : "FORNITORE"}
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="dbx-parties-detail-body-identifying-address">
                {completeAddress}
                <FontAwesomeIcon icon={["far", "map-marker-alt"]} />
              </div>
              <div className="dbx-parties-detail-body-identifying-fiscal">
                {vatNumber && (
                  <div>
                    P.iva:<span>{vatNumber}</span>
                  </div>
                )}
                {taxId && (
                  <div>
                    Codice fiscale:<span>{taxId}</span>
                  </div>
                )}
              </div>
            </div>
            <div className="dbx-parties-detail-body-identifying-bottom"></div>
          </div>
        ) : selectedTab === 2 ? (
          <>
            <div className="dbx-parties-detail-payments-container">
              <h4 className="dbx-parties-detail-payments"> Pagamenti </h4>
              <div className="dbx-parties-detail-body-identifying-name-edit">
                <FontAwesomeIcon
                  icon={["far", "edit"]}
                  onClick={() => setSelectedTab(4)}
                />
              </div>
            </div>
            {negotiatedPaymentPlan.map((installment, index) => {
              return (
                <InstallmentSummary key={`negotiatedPaymentPlan_${index}`} index={index} installment={installment} />
              );
            })}
          </>
        ) : selectedTab === 4 ? (
          <>
            <RecurrentPaymentForm
              paymentDetails={registryStore.paymentDetails}
              setPaymentDetails={registryStore.setPaymentDetails}
              onChangeIban={registryStore.onChangeIbanPaymentForm}
              ibanError={registryStore.ibanError}
              setInstallments={registryStore.setInstallments}
              installments={registryStore.installments}
              installmentsError={registryStore.installmentsError}
              setInstallmentsError={registryStore.setInstallmentsError}
              isEdit={address?.negotiatedPaymentPlans.length > 0 ? true : false}
              address={address}
              installmentsToEdit={installmentsToEdit}
              setInstallmentsToEdit={setInstallmentsToEdit}
            />
          </>
        ) : selectedTab === 3 ? (
          <RegistryForm
            contactBody={registryStore.contactBody}
            setContactBody={registryStore.setContactBody}
            vatNumber={registryStore.vatNumber}
            setVatNumber={registryStore.setVatNumber}
            taxId={registryStore.taxId}
            setTaxId={registryStore.setTaxId}
            eoriNumber={registryStore.eoriNumber}
            setEoriNumber={registryStore.setEoriNumber}
            country={registryStore.country}
            setCountry={registryStore.setCountry}
            emailAddress={registryStore.emailAddress}
            setEmailAddress={registryStore.setEmailAddress}
            pecAddress={registryStore.pecAddress}
            setPecAddress={registryStore.setPecAddress}
            address={registryStore.address}
            setAddress={registryStore.setAddress}
            onBlurMunicipality={registryStore.onBlurMunicipality}
            municipalityError={registryStore.municipalityError}
            onBlurProvince={registryStore.onBlurProvince}
            provinceError={registryStore.provinceError}
            countries={registryStore.optionCountries}
            onChangeCountry={registryStore.onChangeCountry}
            onBlurCap={registryStore.onBlurCap}
            capError={registryStore.capError}
            ibanError={registryStore.ibanError}
            onChangeIban={registryStore.onChangeIbanPaymentForm}
            emailError={registryStore.emailError}
            pecError={registryStore.pecError}
            onBlurEmail={registryStore.onBlurEmail}
            onBlurPec={registryStore.onBlurPec}
            contact={address}
            isEdit={true}
            setMunicipalityError={registryStore.setMunicipalityError}
            setProvinceError={registryStore.setProvinceError}
            setCapError={registryStore.setCapError}
            editContactBody={editContactBody}
            setEditContactBody={setEditContactBody}
            editVatNumber={editVatNumber}
            setEditVatNumber={setEditVatNumber}
            editTaxId={editTaxId}
            setEditTaxId={setEditTaxId}
            editEoriNumber={editEoriNumber}
            setEditEoriNumber={setEditEoriNumber}
            editEmailAddress={editEmailAddress}
            setEditEmailAddress={setEditEmailAddress}
            editPecAddress={editPecAddress}
            setEditPecAddress={setEditPecAddress}
            editAddress={editAddress}
            setEditAddress={setEditAddress}
            municipalityEditError={municipalityEditError}
            provinceEditError={provinceEditError}
            capEditError={capEditError}
            pecEditError={pecEditError}
            taxIdEditError={taxIdEditError}
            ibanEditError={ibanEditError}
            emailEditError={emailEditError}
            onEditCountry={onEditCountry}
            onBlurEditMunicipality={onBlurEditMunicipality}
            onBlurEditCap={onBlurEditCap}
            onBlurEditProvince={onBlurEditProvince}
            onBlurEditPec={onBlurEditPec}
            onChangeEditIbanValue={onChangeEditIbanValue}
            onBlurEditEmail={onBlurEditEmail}
            onBlurEditTaxId={onBlurEditTaxId}
            vatEditError={vatEditError}
            onBlurEditVatNumber={onBlurEditVatNumber}
            contactPecAddress={contactPecAddress}
            contactTaxId={contactTaxId}
            contactVatNumber={contactVatNumber}
          />
        ) : null}
      </div>
      {selectedTab === 3 || selectedTab === 4 ? (
        <div
          className="dbx-register-modal-footer"
          style={{ marginBottom: "50px" }}
        >
          <Button
            tabIndex={20}
            kind="secondary"
            colorScheme={"ghost"}
            style={{ marginRight: "16px" }}
            className="buttonNav"
            onClick={() => {
              onClose(null);
            }}
          >
            Annulla
          </Button>
          <Button
            tabIndex={19}
            kind="primary"
            style={{ marginRight: "16px" }}
            className="buttonNav"
            disabled={!buttonActiveConditions()}
            onClick={() => {
              editContact();
              if (window.aptrinsic) {
                window.aptrinsic("track", "digital-box:MODIFY-CONTACT");
              }
            }}
          >
            Salva
          </Button>
        </div>
      ) : null}
    </VaporDrawer>
  );
};

export default PartiesDetail;
